import { createContext, useContext } from "react";

export interface IUser {
  id: string | number;
  name: string;
  avatar: string;
  role: string;
  profile: string;
  hasAdministrationAccess?: boolean;
  firstName?: string;
}

export const initialUserState: IUser = {
  id: -1,
  name: "",
  avatar: "",
  role: "admin",
  profile: "/",
  firstName: "",
};

export interface IAuthContext {
  user: IUser;
  isLoggedIn: boolean;
  isLoading: boolean;
  handleLogin: (payload: any, role?: any) => void;
  handleLogout: () => void;
}

const initialState: IAuthContext = {
  user: initialUserState,
  isLoggedIn: false,
  isLoading: true,
  handleLogin: () => {},
  handleLogout: () => {},
};

const AuthContext = createContext(initialState);

export default AuthContext;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }

  return context;
};
